import { useTranslation } from "react-i18next";
// import { Modal } from "../../../../../../components/modal";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { managerProduct } from "../../../../../../services/manager.service";
import { DeadLineAlert, MaterialConfirmItem, MaterialConfirmList, ModalAddProductStyled } from "./styled";
import { formatDeadline } from "../../../../../../utils/formatDeadline";
import formatCurrency from "../../../../../../utils/formatCurrency";
import { MdOutlineInfo } from "react-icons/md";

interface IModalAddOrderProduct {
	show: boolean;
	isLoading: boolean;
	onSubmit: (products: any) => void;
	onHide: () => void;
}

export const ModalAddOrderProduct: React.FC<IModalAddOrderProduct> = (
	props
) => {
	const { show, isLoading, onSubmit, onHide } = props;
	const { t: translation } = useTranslation();

	// Material Type
	const [materialType, setMaterialType] = useState<any>();
	const materialTypeItems = [
		{ label: translation("manager.type.discipline"), value: "Discipline" },
		{ label: translation("manager.type.object"), value: "Media" },
		{ label: translation("manager.type.theme"), value: "Theme" },
		{ label: translation("manager.type.unity"), value: "Item" },
	];

	// Lazy-load
	const [hasMorePages, setHasMorePages] = useState(true);
	const [selectItemsLoading, setSelectItemsLoading] = useState(false);
	const materialSelectRef = useRef<MultiSelect>(null);

	// Pagination
	const [currentPage, setCurrentPage] = useState<number>(1);

	// Objects
	const [filters, setFilters] = useState<any>({});
	const [materialList, setMateriaList] = useState<any>([]);
	const [disciplinesSelected, setDisciplinesSelected] = useState<any>([]);

	useEffect(() => {
		if (filters && materialType) {
			getMaterialList(filters);
		}
	}, [filters]);

	useEffect(() => {
		if (materialType) {
			setCurrentPage(1);
			setMateriaList([]);
			setHasMorePages(true);
			setDisciplinesSelected([]);
			setFilters({ ...filters, page: 1, product_type: materialType });
		}
	}, [materialType]);

	const objectsItemsTemplate = (option: any) => {
		return (
			<div
				className="material-item d-flex w-100 justify-content-between"
				style={{ gap: "15px" }}
			>
				<div className="mb-1">
					<span
						style={{ whiteSpace: "normal", wordBreak: "break-all" }}
					>
						{option.data.title}
					</span>
					<div
						className="mt-1"
						style={{ color: "#A5A5A5" }}
					>
						{formatDeadline(option.data.deadline_id)}
					</div>
				</div>
				<div
					className="my-auto"
					style={{ color: "#A5A5A5" }}
				>
					<div>{formatCurrency(option.data.price)}</div>
				</div>
			</div>
		);
	};

	const handleResponse = (data: any) => {
		setHasMorePages(data.next?.length > 0);
		setCurrentPage((prev) => prev + 1);
		setMateriaList([...materialList, ...data.results]);
	};

	const getMaterialList = (filters: any) => {
		if (hasMorePages) {
			managerProduct(filters)
				.then((data) => {
					handleResponse(data);
				})
				.finally(() => {
					setSelectItemsLoading(false);
				});
		}
	};

	/**
	 * scroll observer do select que terá lazy-load
	 * inicia um novo carregamento quando este chegar ao threshold
	 */
	const handleSelectScroll = (event: Event, page: number) => {
		let target = event.target as HTMLDivElement;
		let targetMaxHeight =
			parseInt(target.style.maxHeight.split(`px`)[0]) ?? 0;

		let scrollPercentage =
			target.scrollTop / (target.scrollHeight - targetMaxHeight);

		if (scrollPercentage > 0.8) {
			// ver se existe uma próxima página a ser carregada
			// ver se já existe algo carregando
			if (hasMorePages && !selectItemsLoading) {
				// colocar a próxima página para carregar
				setSelectItemsLoading(true);
			}
		}
	};

	// gatilho para o lazy loading do select
	useEffect(() => {
		if (selectItemsLoading) {
			setFilters({ ...filters, page: currentPage });
		}
	}, [selectItemsLoading]);

	/**
	 * Método chamado pelo MultiSelect ao abrir o overlay
	 * adiciona um eventlistener no scroll da lista de itens
	 * @param name o nome do select que invocou o método
	 */
	const checkIfLazyloaded = (page: number) => {
		// por enquanto só lazy load nos objetos
		materialSelectRef.current
			?.getOverlay()
			?.querySelector(`.p-multiselect-items-wrapper`)
			?.addEventListener(`scroll`, (event) =>
				handleSelectScroll(event, page)
			);
	};

	const handleMaterialPrice = () => {
		let price = 0;
		disciplinesSelected.map((material: any) => {
			price += material.data.price;
		});
		return price;
	};

	const handleHasFourthDayMaterial = () => {
		let exists = disciplinesSelected.filter((material: any) => material.data.deadline_id === 2);
		return exists.length
	}


	// Step Handle
	const [step, setStep] = useState<any>(1);

	const handleOnConfirm = () => {
		if(step === 1){
			setStep(2)
		}

		if(step === 2){
			const result = disciplinesSelected.map((obj: any) => obj.data.id);
			onSubmit({products: result, type: materialType})
		}
	}

	const handleCancel = () => {
		if(step === 2){
			setStep(1);
			return;
		}
		onHide();
	}

	return (
		<ModalAddProductStyled
			size="md"
			loading={isLoading}
			show={show}
			submitButtonText={translation("manager.user.confirm")}
			variant="form-modal-default"
			hasDefaultIcon={false}
			headerTitle={"Adicionar materiais"}
			onHide={onHide}
		>
			<Modal.Header
				className=""
				closeButton
			>
				<Modal.Title>Adicionar materiais</Modal.Title>
			</Modal.Header>
			<Modal.Body className="px-3">
				{step === 1 && (
					<Form>
						<Row>
							<Col>
								<p className="description">
									Escolha o tipo e os materiais que gostaria
									de incluir no pedido:
								</p>
							</Col>
						</Row>

						<Row>
							<Col
								xs={12}
								className="mb-3"
							>
								<Form.Group>
									<Form.Label>Tipo de material</Form.Label>
									<Dropdown
										className="w-100 select-form-default"
										options={materialTypeItems}
										value={materialType}
										onChange={(e) => {
											setMaterialType(e.value);
										}}
									/>
								</Form.Group>
							</Col>
							<Col
								xs={12}
								className="mb-3"
							>
								<Form.Group>
									<Form.Label>Material</Form.Label>
									<div>
										<MultiSelect
											ref={materialSelectRef}
											maxSelectedLabels={-1}
											selectedItemsLabel={
												"{0} " +
												translation(
													"filters.selectedLabel"
												)
											}
											value={disciplinesSelected}
											appendTo="self"
											optionLabel="name"
											itemTemplate={objectsItemsTemplate}
											disabled={
												materialType ? false : true
											}
											placeholder={"Selecione o material"}
											className="multiselect-dropdown ds-select w-100"
											options={materialList}
											onChange={(event: any) =>
												setDisciplinesSelected(
													event.value
												)
											}
											filter
											selectAll={false}
											onShow={() => {
												checkIfLazyloaded(currentPage);
											}}
										/>
									</div>
								</Form.Group>
							</Col>
							<Col
								xs={12}
								className="mb-3"
							>
								<Form.Group>
									<Form.Label>Total</Form.Label>
									<Form.Control
										disabled={true}
										value={formatCurrency(
											handleMaterialPrice()
										)}
									></Form.Control>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				)}

				{step === 2 && (<>
					<Row>
						<Col xs={12}>
							<p className="m-0">Ao avançar, o montante de <b>{formatCurrency(handleMaterialPrice())}</b> será incluído ao pedido. Você tem certeza de que deseja prosseguir?</p>
						</Col>
						{ handleHasFourthDayMaterial() > 0 &&
							<Col xs={12} className="my-4">
								<DeadLineAlert>
									<div className="d-flex">
										<div className="mx-3"><MdOutlineInfo size={20}/></div>
										<div><p className="m-0">Este pedido inclui materiais com um prazo de 20 dias, podendo impactar a disponibilidade dos arquivos.</p></div>
									</div>
								</DeadLineAlert>
							</Col>
						}
					</Row>
					<Row>
						<Col>
							<p>Materiais que serão adicionados:</p>
						</Col>
					</Row>
					<Row>
						<Col>
							<MaterialConfirmList>
								{disciplinesSelected.map((material: any) => (
									<MaterialConfirmItem>
										<Row>
											<Col xs={6} className="title">{material.data.title}</Col>
											<Col className="deadline">{formatDeadline(material.data.deadline_id)}</Col>
											<Col className="price">{formatCurrency(material.data.price)}</Col>
										</Row>
									</MaterialConfirmItem>
								))}
							</MaterialConfirmList>
						</Col>
					</Row>
					<Row className="mt-3">
						<Col>Total adicional:</Col>
						<Col className="d-flex justify-content-end"><b>{formatCurrency(handleMaterialPrice())}</b></Col>
					</Row>
				</>)}
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="outline-primary"
					className="mb-1"
					disabled={isLoading}
					onClick={() => handleCancel()}
				>
					{ step === 2 ? 'Voltar' : translation("cancel")}
				</Button>

				<div>
					<Button
						type="button"
						variant={"primary"}
						className="mb-1"
						disabled={isLoading}
						onClick={() => handleOnConfirm()}
					>
						{ step === 2 ? translation("manager.user.confirm") : 'Continuar' }
					</Button>
					{isLoading && (
						<Spinner
							animation="border"
							variant={"primary"}
							style={{
								width: "1.2rem",
								height: "1.2rem",
								borderWidth: "0.15em",
								borderRightColor: "transparent",
								marginLeft: "5px",
							}}
						/>
					)}
				</div>
			</Modal.Footer>
		</ModalAddProductStyled>
	);
};
